import server from 'utils/request';

// 当事人接口
/**
 * 当事人案件列表
 * @param data
 */
export function partyCase(data) {
  return server({
    url: '/case/query/partyGetCaseList',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 回答问题
 * @param data
 */
export function answer(data) {
  return server({
    url: '/case/question/answer',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 回答问题
 * @param data
 */
export function questionReply(data) {
  return server({
    url: '/case/question/reply',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 质证
 * @param data
 */
export function evidenceReply(data) {
  return server({
    url: '/case/evidence/reply',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 查询审核记录
 * @param data
 */
export function queryAudits(data) {
  return server({
    url: '/case/query/audits',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 举证
 * @param data
 */
export function proof(data) {
  return server({
    url: '/case/evidence/proof',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 查看已经结案的仲裁书信息
 * @param data
 */
export function queryJudge(data) {
  return server({
    url: '/case/party/queryClosedJudge',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 选择仲裁员
 * @param data
 */
export function groupTrail(data) {
  return server({
    url: '/case/party/groupTrail',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 证据列表
 * @param caseTempNo
 */
export function evidenceList(caseTempNo) {
  var data = {
    caseTempNo
  };
  return server({
    url: '/case/evidence/list',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 证据修改
 * @param caseTempNo
 */
export function evidenceUpdate(data) {
  return server({
    url: '/case/evidence/update',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 获取费用详情
 * @param caseTempNo
 */
export function getCaseFeeInfo(params) {
  return server({
    url: '/pay/getCaseFeeInfo',
    method: 'get',
    params
  })
}

/**
 * 缴费
 * @param params
 */
export function pay(params) {
  return server({
    url: '/pay/alipay',
    method: 'get',
    responseType: 'blob',
    params
  })
}
/**
 * 缴费
 * @param params
 */
export function jhpay(params) {
  return server({
    url: `/bank/b2CRecvOrder`,
    method: 'get',
    responseType: 'blob',
    params
  })
}

/**
 * 缴费状态获取
 * @param data
 */
export function payStatus(data) {
  // var data = {
  //   caseTempNo
  // };
  return server({
    url: '/pay/checkPay',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 缴费状态获取
 * @param data
 */
export function reducePay(data) {
  return server({
    url: '/bank/reduce',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 查询仲裁员列表
 * @param data
 */
export function queryArbitrator(data) {
  return server({
    url: '/case/trial/queryArbitrator',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 查询答辩列表
 * @param data
 */
export function replyList(caseTempNo) {
  var data = {
    caseTempNo
  };
  return server({
    url: '/case/reply/list',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 答辩
 * @param data
 */
export function reply(data) {
  return server({
    url: '/case/reply/insert',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 *  查看答辩状
 * @param replyId
 */
export function getReply(replyId) {
  var params = {
    replyId
  };
  return server({
    url: '/case/reply/view',
    method: 'get',
    params
  })
}

/**
 * 管辖异议/仲裁员回避
 * @param data
 */
export function operate(data) {
  return server({
    url: '/case/power/operate',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 新增代理人
 * @param data
 */
export function addAgent(data) {
  return server({
    url: '/case/party/addAgent',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 更换代理人
 * @param data
 */
export function updateAgent(data) {
  return server({
    url: '/case/party/updateAgent',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 变更手机号
 * @param data
 */
export function changePhone(data) {
  return server({
    url: '/case/party/changePhone',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 获取邮箱验证码
 * @param data
 */
export function getEmailCode(data) {
  return server({
    url: '/case/party/getEmailCode',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 获取手机验证码
 * @param data
 */
export function getSmsCode(data) {
  return server({
    url: '/case/party/getSmsCode',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 变更邮箱
 * @param data
 */
export function changeEmail(data) {
  return server({
    url: '/case/party/changeEmail',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 获取仲裁员详情
 * @param data
 */
export function getArbitrator(userAccount) {
  var data = {
    userAccount
  };
  return server({
    url: '/case/trial/queryArbInfo',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 审核 仲裁员回避审核、管辖异议审核、反请求审核
 * @param data
 */
export function powerDetails(data) {
  return server({
    url: '/case/power/details',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 管辖异议答辩
 * @param data
 */
export function powerReply(data) {
  return server({
    url: '/case/power/reply',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 其他申请 / 裁决更正
 * @param data
 */
export function apply(data) {
  return server({
    url: '/case/power/insert/apply',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/* 其他文件提交 */

/**
 * 新增其他文件提交
 * @param data
 */
export function insertSubmit(data) {
  return server({
    url: '/other/insert/submit',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 修改其他文件提交
 * @param data
 */
export function updateSubmit(data) {
  return server({
    url: '/other/update/submit',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 删除其他文件提交
 * @param data
 */
export function deleteSubmit(data) {
  return server({
    url: '/other/del/submit',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 删除其他文件提交
 * @param data
 */
export function querySubmit(data) {
  return server({
    url: '/other/query/submit',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}


/**
 *  添加意见反馈表
 * @param data
 */
export function feedbackSubmit(data) {
  return server({
    url: '/case/judge/feedback',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}


// WEBPACK FOOTER //
// ./src/api/party/party.js